import { NavLink } from 'react-router';
import { useAuth } from '../context/AuthContext';
import { ACCOUNT_NAV_ITEMS, TOOL_NAV_ITEMS } from '../constants/navigation';
import '../styles/mobile.css';

function MobileAppHeader() {
  const { user, isAuthenticated, isLoading, logout } = useAuth();
  const navItems = isAuthenticated
    ? [...TOOL_NAV_ITEMS, ...ACCOUNT_NAV_ITEMS]
    : TOOL_NAV_ITEMS;

  return (
    <header className="mobile-game-header" role="banner">
      <div className="mobile-app-header-top">
        <h1 className="mobile-game-title">EQ Your Ears</h1>
        {isLoading ? (
          <div className="mobile-app-header-loading" role="status">
            <span className="visually-hidden">Checking authentication...</span>
          </div>
        ) : user ? (
          <div className="mobile-game-user">
            <span
              className="mobile-user-name"
              aria-label={`Logged in as ${user.displayName || user.email}`}
            >
              {user.displayName || user.email}
            </span>
            <button
              onClick={logout}
              className="mobile-logout-btn"
              aria-label="Log out"
            >
              Logout
            </button>
          </div>
        ) : (
          <nav className="mobile-game-auth" aria-label="Authentication">
            {/* A full page load serves the correct public or authenticated bundle. */}
            <a
              href="/login"
              className="mobile-header-btn mobile-header-btn--secondary"
            >
              Sign In
            </a>
            <a
              href="/signup"
              className="mobile-header-btn mobile-header-btn--primary"
            >
              Sign Up
            </a>
          </nav>
        )}
      </div>

      <nav className="mobile-app-nav" aria-label="App sections">
        {navItems.map(({ id, to, label }) => (
          <NavLink
            key={id}
            to={to}
            end
            className={({ isActive }) =>
              `mobile-app-nav__link${isActive ? ' mobile-app-nav__link--active' : ''}`
            }
          >
            {label}
          </NavLink>
        ))}
      </nav>
    </header>
  );
}

export default MobileAppHeader;
